import React, { useState } from "react";
import styled from "styled-components";
import MfaOption from "sub_components/Login/MfaOption";
import { LoadingSpinner } from "../Common/LoadingSpinner";
//import LoginInput from '../../sub_components/Login/LoginInput';

const Style = styled.div`
  width: 30rem;
  height: 20rem;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .error-message {
    color: #f23722;
    position: absolute;
    top: 35%;
  }

  perspective: 30em;
  background-color: rgba(88, 58, 107, 0.6);

  .message_section {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem !important;
    margin-top: 3rem;
    margin-bottom: 3rem;
    .message_text {
      font-size: 1.8rem;
    }
  }

  .login-card {
    width: 100%;
    height: 100%;
    position: relative;
    transition: transform 0.5s;
    transform-style: preserve-3d;
    &.step-two {
      transform: rotateY(180deg);
    }
  }

  .login-form {
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: center;
    position: absolute;
    backface-visibility: hidden;
    transform: rotateX(0deg);
    &.step-two {
      transform: rotateY(180deg);
    }
    .loading-spinner {
      height: 3rem;
    }
    .input-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid rgba(88, 58, 107);
      flex: 1;
      .label {
        width: 20%;
        height: 100%;
      }
    }

    input {
      width: 100%;
      height: 4rem;
      padding-left: 1rem;
      color: #ffffff;
      background-color: rgba(88, 58, 107, 0.4);
      border: none;
      border-left: none;
      font-size: 1rem;
    }
    ::placeholder {
      color: #ffffff;
    }
    .selection {
      height: 4rem;
    }
    button {
      width: 100%;
      height: 4rem;
      background-color: rgba(88, 58, 107);
      cursor: pointer;
      color: #ffffff;
      font-size: 1.5rem;
      border: none;
    }
    button:disabled {
      opacity: 0.4;
    }
    button:active {
      background-color: rgba(88, 58, 107, 0.5);
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    width: 40rem;
    height: 23rem;

    .error-message {
      top: 28%;
    }

    perspective: 30em;

    .message_section {
      height: 2rem !important;
      margin-top: 3rem;
      margin-bottom: 3rem;
      .message_text {
        font-size: 1.8rem;
      }
    }

    .login-form {
      .loading-spinner {
        height: 3rem;
      }

      input {
        height: 5rem;
        padding-left: 1rem;

        font-size: 1rem;
      }
      .selection {
        height: 5rem;
      }
      button {
        width: 100%;
        height: 5rem;

        font-size: 1.5rem;
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    width: 40rem;
    height: 23rem;

    .error-message {
      top: 28%;
    }

    perspective: 30em;

    .message_section {
      height: 2rem !important;
      margin-top: 3rem;
      margin-bottom: 3rem;
      .message_text {
        font-size: 1.8rem;
      }
    }

    .login-form {
      .loading-spinner {
        height: 3rem;
      }

      input {
        height: 5rem;
        padding-left: 1rem;

        font-size: 1rem;
      }
      .selection {
        height: 5rem;
      }
      button {
        width: 100%;
        height: 5rem;

        font-size: 1.5rem;
      }
    }
  }
`;

export const LoginContainer = ({
  receiveInput,
  auth_status,
  enabled,
  forceShow,
  updateMFAoption,
  mfaOptionRequest,
  code,
  setMFACode,
  resetLogin,
  resetMfaOptions,
  mfaRequestType,
}) => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    status,
    type,
    user: { emailPartial, mobilePhonePartial } = {},
  } = auth_status;
  const showMfaOptions =
    (type !== "LOGIN_SUCCESS_PHASE_ONE_NO_MFA" && status === "LOGIN_SUCCESS") ||
    status === "MFA_ERROR";
  if (status === "LOGIN_ERROR" && password !== "" && loading) {
    setPassword("");
    setEmail("");
    setLoading(false);
  }
  const validInput =
    email && email.length !== 0 && password && email.length !== 0
      ? true
      : false;

  const doc = document.getElementById("login-card");
  if (showMfaOptions) {
    if (doc && !doc.classList.contains("step-two")) {
      doc.classList.add("step-two");
    }
  } else if (status.includes("USERNAME_RESET")) {
    doc.classList.remove("step-two");
  }
  function onClickHandler(e) {
    if (e.key === "Enter" || e.type === "click") {
      setLoading(true);
      receiveInput(email, password);
    }
  }

  function resetLoginHandler() {
    setLoading(false);
    setPassword("");
    setEmail("");
    resetLogin();
  }

  return (
    <Style className="login-container">
      {" "}
      {/* <div key='login-input' className='login-form grid-item-rh'>
				<LoginInput checkCompletionCallback={checkCompletion} dispatch={dispatch} />
			</div> */}
      <div className="message_section">
        <span data-cy="login-message-text" className="message_text">
          Customer Portal Login
        </span>
      </div>
      {status === "LOGIN_ERROR" && (
        <span className="error-message labels21">Invalid Credentials</span>
      )}
      {error && <span className="error-message labels21">{error}</span>}
      {type === "LOGIN_ERROR_PHASE_TWO" && (
        <span className="error-message labels21">Invalid Code</span>
      )}
      <div className="login-card shadow" id="login-card">
        <div className="login-form step-one">
          <div className="input-wrapper">
            <div className="label body10">Email</div>
            <input
              id="usernameInput"
              value={email}
              className="body10"
              type="email"
              placeholder="example@domain.com"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-wrapper">
            <div className="label body10">Password</div>
            <input
              id="pwdInput"
              value={password}
              className="body10"
              type="password"
              placeholder="*****"
              onKeyDown={onClickHandler}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="d-grid">
            <button
              id="login-button"
              variant="primary"
              type="submit"
              className="labels21"
              onClick={onClickHandler}
              disabled={loading || !validInput}
            >
              {!loading || status === "LOGIN_ERROR" ? (
                "Login"
              ) : (
                <LoadingSpinner />
              )}
            </button>
          </div>
        </div>
        <div className="login-form step-two">
          <MfaOption
            selectedCallback={updateMFAoption}
            mfaOptionRequest={mfaOptionRequest}
            auth_status={auth_status}
            email={emailPartial}
            phone={mobilePhonePartial}
            forceShow={forceShow}
            enabled={enabled}
            inputEnterCallback={receiveInput}
            disabledMfaTimeout={() => {}}
            requestType={mfaRequestType}
            resetLogin={resetLoginHandler}
            resetMfaOptions={resetMfaOptions}
            code={code}
            setMFACode={setMFACode}
            setError={setError}
            userEmail={email}
          />
        </div>
      </div>
    </Style>
  );
};
